import Ellipsis from './Ellipsis.vue'

export default Ellipsis
